import { format } from 'date-fns';

import path from 'utils/path';
import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/Challenges',
  link: '/general/Challenges',
  goLeaderBoard: ({ id, challengeName }) => path(id, `/leaderboard/?challengeName=${challengeName}`),
};

export const getColumns = ({ deleteItem, editItem, leaderBoard }) => {
  const menuItems = [
    { id: 2, name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
    { id: 3, name: 'Leader board', action: leaderBoard, icon: 'mdi:text-box-multiple-outline' },
  ];

  return [
    { id: 'name', label: 'Challenge', align: 'left', nameForSort: 'name' },
    {
      id: 'startDate',
      label: 'Start Date',
      customValue: (val) => format(new Date(val.startDate), 'dd MMM yyyy'),
      align: 'center',
      nameForSort: 'start_date',
    },
    {
      id: 'endDate',
      label: 'End Date',
      customValue: (val) => format(new Date(val.endDate), 'dd MMM yyyy'),
      align: 'center',
      nameForSort: 'end_date',
    },
    {
      id: 'measurement',
      label: 'Measurement',
      align: 'center',
      nameForSort: 'measurement',
    },
    {
      id: 'region',
      label: 'Region',
      align: 'center',
      nameForSort: 'region',
    },
    {
      id: 'corporateName',
      label: 'Corporate',
      align: 'center',
      disableSort: true,
    },
    {
      id: 'showOnFrontend',
      label: 'Frontend',
      align: 'center',
      customValue: (val) => (val.showOnFrontend ? 'Active' : 'Inactive'),
      nameForSort: 'show_on_frontend',
    },
    {
      id: 'oakley',
      label: 'Oakley',
      align: 'center',
      customValue: (val) => (val.oakley ? 'True' : 'False'),
      nameForSort: 'oakley',
    },
    {
      id: 'active',
      label: 'Active',
      align: 'center',
      customValue: (val) => (val.active ? 'Active' : 'Inactive'),
      nameForSort: 'active',
    },
    {
      id: 'more-menu',
      type: 'menu',
      items: checkAccess([5])
        ? [...menuItems]
        : [
            {
              id: 1,
              name: 'Delete',
              action: (id) => deleteItem(id),
              icon: 'eva:trash-2-outline',
              sx: { color: 'error.main' },
            },
            ...menuItems,
          ],
      disableSort: true,
    },
  ];
};

export const getFilters = ({ dateRange, corporateId, region, showOnFrontend, active, oakley, searchBy, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Challenge name',
    defaultValue: searchBy.defaultValue,
    action: searchBy.change,
  },
  {
    id: 'dateRange',
    variant: 'date',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'regions',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'corporateId',
    type: 'autocomplete',
    label: 'Corporate',
    value: corporateId.value,
    action: corporateId.change,
    items: options?.corporations ? ['All', 'Public', ...options.corporations] : ['All', 'Public'],
  },
  {
    id: 'active',
    type: 'switch',
    label: 'Active',
    value: active.value === 'true',
    action: active.change,
  },
  {
    id: 'showOnFrontend',
    type: 'switch',
    label: 'Show on frontend',
    value: showOnFrontend.value === 'true',
    action: showOnFrontend.change,
  },
  {
    id: 'oakley',
    type: 'switch',
    label: 'Oakley',
    value: oakley.value === 'true',
    action: oakley.change,
  },
];
